<template>
  <w-icon-wrapper icon-name='work-widget-icon'>
    <g
      id="_87_Widgets_Icon"
      data-name="87 Widgets_Icon"
      transform="translate(0 0.197)"
    >
      <path
        id="Pfad_55835"
        data-name="Pfad 55835"
        d="M5,13.8v8H2v-8H5m2-2H0v12H7v-12Z"
        fill="currentColor"
      />
      <path
        id="Pfad_55836"
        data-name="Pfad 55836"
        d="M10,1.8v6H2v-6h8m2-2H0v10H12V-.2Z"
        fill="currentColor"
      />
      <path
        id="Pfad_55837"
        data-name="Pfad 55837"
        d="M22,1.8v6H16v-6h6m2-2H14v10H24V-.2Z"
        fill="currentColor"
      />
      <path
        id="Pfad_55838"
        data-name="Pfad 55838"
        d="M22,13.8v8H11v-8H22m2-2H9v12H24v-12Z"
        fill="currentColor"
      />
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconWidget' };
</script>
